//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'MdmLoader',
  props: {
    fill: {
      type: String,
      default: '#3c3c3b'
    },
    show: {
      type: Boolean,
      default: true
    }
  }
};